import { DateTime } from 'luxon';

const EASTERN_ZONE = 'America/New_York';

export function getFuturesTradingDay(isoDateString) {
  const eastern = DateTime.fromISO(isoDateString, { zone: EASTERN_ZONE }).setZone(
    EASTERN_ZONE
  );
  if (!eastern.isValid) return '';
  const sessionEndDate = eastern.hour >= 18 ? eastern.plus({ days: 1 }) : eastern;
  return sessionEndDate.toFormat('yyyy-LL-dd');
}
